import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, mergeProps as _mergeProps, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "cs-avatar" }
const _hoisted_2 = { class: "cs-info" }
const _hoisted_3 = { class: "cs-name" }
const _hoisted_4 = { class: "cd-head" }
const _hoisted_5 = { class: "cd-count" }
const _hoisted_6 = {
  key: 0,
  class: "company-search"
}
const _hoisted_7 = { class: "company-list" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "company-name" }
const _hoisted_10 = {
  key: 0,
  class: "company-empty"
}
const _hoisted_11 = { class: "us-avatar" }
const _hoisted_12 = { class: "user-name" }
const _hoisted_13 = { class: "um-head" }
const _hoisted_14 = { class: "um-avatar" }
const _hoisted_15 = { class: "um-info" }
const _hoisted_16 = { class: "um-name" }
const _hoisted_17 = { class: "um-role" }
const _hoisted_18 = { class: "um-list" }
const _hoisted_19 = { class: "drawer-footer-section" }
const _hoisted_20 = {
  key: 0,
  class: "card-header-fixed"
}
const _hoisted_21 = {
  key: 0,
  class: "breadcrumb-section"
}
const _hoisted_22 = { class: "changelog-header" }
const _hoisted_23 = {
  key: 0,
  class: "wn-desc"
}
const _hoisted_24 = {
  key: 1,
  class: "wn-list"
}
const _hoisted_25 = { class: "wn-ghead" }
const _hoisted_26 = {
  key: 0,
  class: "cnt"
}
const _hoisted_27 = {
  key: 0,
  class: "wn-bullets"
}
const _hoisted_28 = {
  key: 2,
  class: "wn-empty"
}
const _hoisted_29 = { class: "changelog-header" }
const _hoisted_30 = { class: "cl-day-label" }
const _hoisted_31 = { class: "cl-timeline" }
const _hoisted_32 = { class: "cl-content" }
const _hoisted_33 = { class: "cl-entry-head" }
const _hoisted_34 = { class: "cl-version" }
const _hoisted_35 = {
  key: 0,
  class: "cl-new-badge"
}
const _hoisted_36 = { class: "cl-time" }
const _hoisted_37 = {
  key: 0,
  class: "cl-desc"
}
const _hoisted_38 = {
  key: 1,
  class: "cl-grouped"
}
const _hoisted_39 = { class: "clg-mod" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = {
  key: 0,
  class: "cl-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BugReportWidget = _resolveComponent("BugReportWidget")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_VBreadcrumbsItem = _resolveComponent("VBreadcrumbsItem")!
  const _component_VBreadcrumbs = _resolveComponent("VBreadcrumbs")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_BugReportWidget, { ref: "bugReport" }, null, 512),
      _createVNode(_component_v_app_bar, {
        color: _ctx.APP_Color,
        elevation: "0",
        height: "56",
        class: "premium-topbar"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar_nav_icon, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.drawer = !_ctx.drawer)),
            color: "white",
            class: "menu-btn"
          }),
          _createVNode(_component_router_link, {
            to: { path: '/' },
            class: "app-branding",
            onClick: _ctx.goHome
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createElementVNode("span", { class: "brand-mark" }, [
                _createElementVNode("span", { class: "brand-text" }, "ERA"),
                _createElementVNode("span", { class: "brand-badge" }, "ERP")
              ], -1),
              _createElementVNode("span", { class: "brand-powered" }, [
                _createTextVNode("Powered by "),
                _createElementVNode("strong", null, "Else Digital Solutions")
              ], -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            icon: "",
            variant: "text",
            color: "white",
            class: "report-btn",
            title: "Raportează o problemă",
            onClick: _ctx.openBugReport
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode("mdi-bug-outline", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_menu, {
            "offset-y": "",
            "close-on-content-click": false
          }, {
            activator: _withCtx(({ props }) => [
              _createElementVNode("button", _mergeProps(props, { class: "company-selector" }), [
                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.companyInitials(_ctx.currentCompanyName)), 1),
                _createElementVNode("span", _hoisted_2, [
                  _cache[12] || (_cache[12] = _createElementVNode("span", { class: "cs-eyebrow" }, "Companie", -1)),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.currentCompanyName), 1)
                ]),
                _createVNode(_component_v_icon, {
                  size: "18",
                  class: "cs-chevron"
                }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createTextVNode("mdi-chevron-down", -1)
                  ]))]),
                  _: 1
                })
              ], 16)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "company-dropdown",
                elevation: "12"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "cd-title" }, "Companii", -1)),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.companies.length), 1)
                  ]),
                  (_ctx.companies.length > 6)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_v_icon, {
                          size: "16",
                          class: "cs-search-ico"
                        }, {
                          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                            _createTextVNode("mdi-magnify", -1)
                          ]))]),
                          _: 1
                        }),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.companySearch) = $event)),
                          type: "text",
                          placeholder: "Caută companie..."
                        }, null, 512), [
                          [_vModelText, _ctx.companySearch]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCompanies, (c) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: c.ID,
                        onClick: ($event: any) => (_ctx.switchCompany(c)),
                        class: _normalizeClass(["company-list-item", { active: c.ID === _ctx.currentCompanyId }])
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["company-avatar", { ring: c.ID === _ctx.currentCompanyId }])
                        }, _toDisplayString(_ctx.companyInitials(c.Name)), 3),
                        _createElementVNode("span", _hoisted_9, _toDisplayString(c.Name), 1),
                        (c.ID === _ctx.currentCompanyId)
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              size: "18",
                              class: "company-check"
                            }, {
                              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                _createTextVNode("mdi-check-circle", -1)
                              ]))]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_8))
                    }), 128)),
                    (!_ctx.filteredCompanies.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Nicio companie găsită."))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_menu, {
            "offset-y": "",
            "close-on-content-click": true
          }, {
            activator: _withCtx(({ props }) => [
              _createElementVNode("button", _mergeProps(props, { class: "user-section" }), [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.userInitials), 1),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.Username), 1),
                _createVNode(_component_v_icon, {
                  size: "18",
                  class: "us-chevron"
                }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                    _createTextVNode("mdi-chevron-down", -1)
                  ]))]),
                  _: 1
                })
              ], 16)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "user-menu",
                elevation: "12"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.userInitials), 1),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.Username), 1),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.isSuperAdminUser ? 'Super Administrator' : 'Utilizator'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    (_ctx.isSuperAdminUser)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "um-item",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goSuperAdmin && _ctx.goSuperAdmin(...args)))
                        }, [
                          _createVNode(_component_v_icon, {
                            size: "18",
                            class: "um-ico"
                          }, {
                            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                              _createTextVNode("mdi-shield-crown", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[20] || (_cache[20] = _createElementVNode("span", null, "Mod SuperAdmin", -1)),
                          _createVNode(_component_v_icon, {
                            size: "16",
                            class: "um-arrow"
                          }, {
                            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                              _createTextVNode("mdi-arrow-right", -1)
                            ]))]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "um-item danger",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.Logout && _ctx.Logout(...args)))
                    }, [
                      _createVNode(_component_v_icon, {
                        size: "18",
                        class: "um-ico"
                      }, {
                        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                          _createTextVNode("mdi-power-standby", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[22] || (_cache[22] = _createElementVNode("span", null, "Deconectare", -1))
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, {
            color: _ctx.APP_Color,
            variant: "text",
            size: "small",
            class: "version-badge",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showAllChangelog = true))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                size: "12",
                class: "mr-1"
              }, {
                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                  _createTextVNode("mdi-information", -1)
                ]))]),
                _: 1
              }),
              _createTextVNode(" v" + _toDisplayString(_ctx.APP_Version), 1)
            ]),
            _: 1
          }, 8, ["color"])
        ]),
        _: 1
      }, 8, ["color"]),
      _createVNode(_component_v_navigation_drawer, {
        app: "",
        modelValue: _ctx.drawer,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.drawer) = $event)),
        color: _ctx.APP_Color,
        theme: "dark",
        elevation: 0,
        permanent: "",
        width: "300",
        class: "premium-drawer"
      }, {
        append: _withCtx(() => [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_v_divider, { class: "footer-divider" }),
            _createVNode(_component_v_list_item, {
              "prepend-icon": "mdi-power-standby",
              title: "Deconectare",
              onClick: _ctx.Logout,
              class: "logout-item"
            }, {
              append: _withCtx(() => [
                _createVNode(_component_v_icon, { size: "18" }, {
                  default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                    _createTextVNode("mdi-exit-to-app", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_list, {
            opened: _ctx.open,
            "onUpdate:opened": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.open) = $event)),
            class: "drawer-menu-list"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Menu.filter(x => x.Level == 1), (row) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: row.ID
                }, [
                  (_ctx.Menu.some(x => x.MenuID == row.ID))
                    ? (_openBlock(), _createBlock(_component_v_list_group, {
                        key: 0,
                        "prepend-icon": row.Icon,
                        class: "menu-group-item"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props, {
                            title: row.Title,
                            class: "menu-parent-item"
                          }), null, 16, ["title"])
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Menu.filter(x => x.MenuID == row.ID), (row2) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: row2.ID
                            }, [
                              (_ctx.Menu.some(x => x.MenuID == row2.ID))
                                ? (_openBlock(), _createBlock(_component_v_list_group, {
                                    key: 0,
                                    "no-action": "",
                                    class: "menu-subgroup-item"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props, {
                                        title: row2.Title,
                                        class: "menu-child-item"
                                      }), null, 16, ["title"])
                                    ]),
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Menu.filter(x => x.MenuID == row2.ID), (row3) => {
                                        return (_openBlock(), _createBlock(_component_v_list_item, {
                                          key: row3.ID,
                                          title: row3.Title,
                                          onClick: ($event: any) => (_ctx.ShowPage(row3.Title, row3.Url)),
                                          class: "menu-grandchild-item"
                                        }, null, 8, ["title", "onClick"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 1,
                                    title: row2.Title,
                                    onClick: ($event: any) => (_ctx.ShowPage(row2.Title, row2.Url)),
                                    class: "menu-child-item"
                                  }, null, 8, ["title", "onClick"]))
                            ], 64))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["prepend-icon"]))
                    : (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 1,
                        title: row.Title,
                        "prepend-icon": row.Icon,
                        onClick: ($event: any) => (_ctx.ShowPage(row.Title, row.Url)),
                        class: "menu-single-item"
                      }, null, 8, ["title", "prepend-icon", "onClick"]))
                ], 64))
              }), 128))
            ]),
            _: 1
          }, 8, ["opened"])
        ]),
        _: 1
      }, 8, ["modelValue", "color"]),
      _createVNode(_component_v_main, { class: "main-content-area" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, {
            fluid: "",
            class: "content-container"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "content-card",
                elevation: "8"
              }, {
                default: _withCtx(() => [
                  (!_ctx.$route.path.startsWith('/documente') && !_ctx.$route.path.startsWith('/comenzi') && !_ctx.$route.path.startsWith('/medical') && !_ctx.$route.path.startsWith('/produse') && !_ctx.$route.path.startsWith('/clase') && !_ctx.$route.path.startsWith('/stocuri'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        (_ctx.breadcrumb.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createVNode(_component_VBreadcrumbs, {
                                items: _ctx.breadcrumb,
                                class: "breadcrumb-custom"
                              }, {
                                divider: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    size: "14",
                                    color: "grey"
                                  }, {
                                    default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                      _createTextVNode("mdi-chevron-right", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                item: _withCtx(({ item }) => [
                                  _createVNode(_component_VBreadcrumbsItem, {
                                    link: !!item.url,
                                    style: _normalizeStyle(item.url ? 'cursor: pointer' : ''),
                                    onClick: ($event: any) => (item.url && _ctx.ShowPage(item.title, item.url))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["link", "style", "onClick"])
                                ]),
                                _: 1
                              }, 8, ["items"])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_divider, {
                          color: _ctx.APP_Color,
                          class: "header-divider"
                        }, null, 8, ["color"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(['card-content-scrollable', { 'full-screen-content': _ctx.isFullScreenRoute }])
                  }, [
                    _createVNode(_component_router_view, {
                      class: _normalizeClass(['router-content', { 'router-content-full': _ctx.isFullScreenRoute }])
                    }, null, 8, ["class"])
                  ], 2)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_footer, { app: "" }),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.showChangelog,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showChangelog) = $event)),
        "max-width": "520px",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "changelog-card" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_v_icon, {
                  color: "white",
                  size: "20",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                    _createTextVNode("mdi-new-box", -1)
                  ]))]),
                  _: 1
                }),
                _createElementVNode("span", null, "Ce e nou în versiunea " + _toDisplayString(_ctx.APP_Version), 1)
              ]),
              _createVNode(_component_v_card_text, { class: "whatsnew-body" }, {
                default: _withCtx(() => [
                  (_ctx.hasDesc(_ctx.latestUpdate[0]?.description))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.latestUpdate[0].description), 1))
                    : _createCommentVNode("", true),
                  (_ctx.groupModules(_ctx.latestUpdate[0]?.modules || []).length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupModules(_ctx.latestUpdate[0].modules), (g, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: i,
                            class: "wn-group"
                          }, [
                            _createElementVNode("div", _hoisted_25, [
                              _cache[27] || (_cache[27] = _createElementVNode("span", { class: "dotm" }, null, -1)),
                              _createTextVNode(_toDisplayString(g.module) + " ", 1),
                              (g.items.length > 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(g.items.length), 1))
                                : _createCommentVNode("", true)
                            ]),
                            (g.items.length)
                              ? (_openBlock(), _createElementBlock("ul", _hoisted_27, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.items, (t, j) => {
                                    return (_openBlock(), _createElementBlock("li", { key: j }, _toDisplayString(t), 1))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : (!_ctx.hasDesc(_ctx.latestUpdate[0]?.description))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, " Îmbunătățiri și corecții interne. "))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "justify-end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "text",
                    onClick: _ctx.markAsSeen
                  }, {
                    default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                      _createTextVNode("Am înțeles", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.showAllChangelog,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showAllChangelog) = $event)),
        "max-width": "660px",
        scrollable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "changelog-card" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_v_icon, {
                  color: "white",
                  size: "20",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                    _createTextVNode("mdi-history", -1)
                  ]))]),
                  _: 1
                }),
                _cache[31] || (_cache[31] = _createElementVNode("span", null, "Istoricul versiunilor", -1)),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "text",
                  density: "comfortable",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showAllChangelog = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      color: "white",
                      size: "20"
                    }, {
                      default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                        _createTextVNode("mdi-close", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_v_card_text, { class: "changelog-body" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.changelogGrouped, (grp) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: grp.day,
                      class: "cl-day-group"
                    }, [
                      _createElementVNode("div", _hoisted_30, _toDisplayString(grp.day), 1),
                      _createElementVNode("div", _hoisted_31, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grp.entries, (entry) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: entry.version,
                            class: "cl-entry"
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["cl-dot", { 'is-new': entry.isNew }])
                            }, null, 2),
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("span", _hoisted_34, "v" + _toDisplayString(entry.version), 1),
                                (entry.isNew)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, "NOU"))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.formatTime(entry.date)), 1)
                              ]),
                              (_ctx.hasDesc(entry.description))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(entry.description), 1))
                                : _createCommentVNode("", true),
                              (_ctx.groupModules(entry.modules || []).length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupModules(entry.modules), (g, i) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: i,
                                        class: "clg"
                                      }, [
                                        _createElementVNode("span", _hoisted_39, _toDisplayString(g.module), 1),
                                        (g.items.length)
                                          ? (_openBlock(), _createElementBlock("ul", _hoisted_40, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.items, (t, j) => {
                                                return (_openBlock(), _createElementBlock("li", { key: j }, _toDisplayString(t), 1))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  }), 128)),
                  (!_ctx.changelogGrouped.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, "Nu există versiuni înregistrate."))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}